// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Carousel_arrow__2dp3N","arrowleft":"Carousel_arrowleft__2lb6e","arrowRight":"Carousel_arrowRight__TIKug","arrowButton":"Carousel_arrowButton__1Aydl"};